import { createRoot } from 'react-dom/client'

import App from '@/App'
import { handleEntraRedirect } from '@/auth/handleEntraRedirect'
import '@/data/api/registerInterceptors'
import { hasExpiredEntraAccessToken } from '@/data/api/token'
import { useAuthStore } from '@/store/authStore'
import '@/styles/index.css'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Failed to find the root element')
}

const root = createRoot(rootElement)

const boot = async () => {
  await handleEntraRedirect()

  // Expired Entra session → fall back to anonymous guest (no forced re-login).
  if (hasExpiredEntraAccessToken()) {
    await useAuthStore.getState().logout()
  }

  root.render(<App />)
}

void boot()
